export default (component) => {
  const propsKeys = component._props ? Object.keys(component._props) : [];
  const dataKeys = component._data ? Object.keys(component._data) : [];
  const watchersKeys = component._computedWatchers ? Object.keys(component._computedWatchers): [];
  return [...propsKeys, ...dataKeys, ...watchersKeys];
};
